import { takeLatest, put, select } from 'redux-saga/effects';
import { activeTargetUserChannelSelector } from '../selectors';
import chatConsts from '../constants';

function* reloadHistoryWorker() {
  const state = yield select();
  const activeChannel = activeTargetUserChannelSelector(state);

  yield put({
    type: chatConsts.FETCH_MESSAGES,
    payload: activeChannel,
  });
}

export default function* reloadHistorySaga() {
  yield takeLatest([chatConsts.RELOAD_HISTORY], reloadHistoryWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/reloadHistory.js